/**
 * Image loading utility to handle image errors gracefully
 */

export const handleImageError = (event: React.SyntheticEvent<HTMLImageElement>) => {
  const img = event.target as HTMLImageElement;
  img.style.display = 'none';
  console.warn(`Failed to load image: ${img.src}`);
};

export const preloadImage = (src: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve();
    img.onerror = reject;
    img.src = src;
  });
};

export const preloadImages = async (images: string[]): Promise<void> => {
  try {
    await Promise.all(images.map(preloadImage));
  } catch (error) {
    console.warn('Some images failed to preload:', error);
  }
};
